export default __webpack_public_path__ + "locales/ar-SA/EmptyView.json?hash=29f99d06a1b63c867f52e430f6de1e15";